<template>
    <div class="container booking-container">
        <div v-if="!isLoggedIn" style="padding-top:130px;"></div>
        <booking-navigation :active-item="activeItem" ref="navigation" :title="pageTitle" :items="bookingNavigationItems" />

        <booking-schedule-section v-if="activeItem == 'booking_schedule'" @next="showServiceSelection" ref="bookingScheduleSection" />
        <service-selection-section v-else-if="activeItem == 'select_services'" :via-shop="true" @next="proceedToCheckout" @previous="returnToBookingScheduleSelection" ref="serviceSelectionSection" />
        <checkout-section v-else-if="activeItem == 'checkout'" @next="proceedToCheckout" @previous="returnToServiceSelection" ref="checkoutSection" />
    </div>
</template>
<script>
import store from "./store";
import mixins from "@utils/mixins";
import { route, get } from '@utils/network';

import BookingNavigation from "../create/partials/BookingNavigation";
import BookingScheduleSection from "./partials/booking-schedule/BookingScheduleSection";
import ServiceSelectionSection from "../create/partials/service-selection/ServiceSelectionSection";
import CheckoutSection from "../create/partials/checkout/CheckoutSection";

export default {
    name: "BookingCreateViaShopPage",
    store,
    components: {
        BookingNavigation, BookingScheduleSection, ServiceSelectionSection, CheckoutSection
    },

    computed: {
        pageTitle() {
            return this.activeItem ? this.activeItem.replace("_", " ") : "";
        },
        shop() {
            return this.$store.getters.shop;
        },
        services() {
            return this.$store.getters.services;
        },
        packages() {
            return this.$store.getters.packages;
        },
        address() {
            return this.$store.getters.address;
        },
        checkoutForm() {
            return {
                shop: this.shop,
                address: this.address,
                services: this.services,
                packages: this.packages
            }
        },
        isLoggedIn() {
            return this.$store.getters.userToken != null;
        },
    },

    data: () => ({
        activeItem: null,
        bookingNavigationItems: [
            "booking_schedule",
            "select_services",
            "checkout",
        ]
    }),

    methods: { 
        setActiveItem(item) {
            window.scrollTo(0,0);
            this.activeItem = item;
        },

        handleSectionErrors(section, error) {
            if (!error) return;
            console.log(error);
            this.$nextTick(() => this.$refs[section].handleErrors(error));
        },

        returnToBookingScheduleSelection(error) {
            this.setActiveItem("booking_schedule");
            this.handleSectionErrors("bookingScheduleSection", error);
        },

        showServiceSelection() {
            this.setActiveItem("select_services");
            this.$store.dispatch("setServicesAndPackages", { packages: [], services: [] });
            this.$nextTick(() => this.$refs.serviceSelectionSection.initialize())
        },

        returnToServiceSelection(error) {
            this.showServiceSelection();
            this.handleSectionErrors("serviceSelectionSection", error);
        },

        proceedToCheckout() {
            this.setActiveItem("checkout");
            this.$nextTick(() => this.$refs.checkoutSection.initialize(this.checkoutForm), 500)
        },
        
        fetchShopDetails() {
            const params = { show_operations: true, show_address: true, show_contacts: true };
            get(route("shops/:id", { id: this.$route.params.id }), { params })
                .then(response => {
                    this.$store.dispatch("setShop", response.data.result.shop);
                    this.activeItem = "booking_schedule";
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors("Please reload the page");
                });
        },
    },

    mixins: [mixins],

    mounted() {
        this.fetchShopDetails();
    }


};
</script>